import React, { useRef } from "react";
import Swiper from "react-id-swiper";
import { SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import styled from "styled-components";
import "../styles/custom.css";

const WrapperAdvertising = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  background: ${(props) => props.theme};
  border-radius: 0px 100px 0px 0px;
  opacity: 0.9;

  @media screen and (max-width: 576px) {
    display: block;
    border-radius: 0px 0px 0px 0px;
  }

  .imageLeft {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    > img {
      height: 100%;
      box-sizing: border-box;
      max-width: 500px;
      width: 100%;
    }

    @media screen and (max-width: 576px) {
      > img {
        width: 70%;
      }
    }
  }

  .textRight {
    overflow: hidden;
    max-width: 600px;
    padding: 0px 30px;
    margin-top: 30px;

    @media screen and (max-width: 1200px) {
      width: 450px;
    }

    @media screen and (max-width: 768px) {
      width: 400px;
    }

    @media screen and (max-width: 576px) {
      margin-top: 0px;
      width: 100%;
    }
  }

  .text-header {
    /* color: #ffffff; */
    /* font-size: 44px; */
    font-size: 50px;
    white-space: nowrap;

    @media screen and (max-width: 1200px) {
      font-size: 30px;
    }

    @media screen and (max-width: 768px) {
      font-size: 20px;
    }

    /* @media screen and (max-width: 576px) {
      font-size: 16px;
    } */
  }

  .text-body {
    > p {
      color: #ffffff;
      font-size: 18px;
    }

    @media screen and (max-width: 1200px) {
      > p {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 768px) {
      > p {
        font-size: 16px;
      }
    }

    /* @media screen and (max-width: 576px) {
      > p {
        font-size: 10px;
      }
    } */
  }

  .customized-swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25px;
    bottom: 0 !important;
    margin: 30px auto;
    width: 100px !important;
    position: relative;
    background: #e8e8e0 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 1px #ffffff, 4px 4px 10px #d1d1d0;
    border-radius: 5px;
    opacity: 1;
  }

  .swiper-pagination-bullet {
    background: ${(props) => props.theme};
  }

  .buttonPre {
    width: 60px;
    height: 60px;
    transform: scale(0.7);
    background: #e8e8e0 0% 0% no-repeat padding-box;
    border-radius: 50%;
    box-shadow: -5px -5px 10px #ffffff, 4px 4px 10px #d1d1d0;
    color: ${(props) => props.buttonTheme};
    opacity: 1;
    z-index: 999;

    @media screen and (max-width: 1200px) {
      transform: scale(0.7);
    }

    @media screen and (max-width: 768px) {
      transform: scale(0.6);
    }

    @media screen and (max-width: 576px) {
      transform: scale(0.5);
    }
  }

  .arrow {
    border: solid;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 10px;

    &.left {
      transform: rotate(135deg) translate(0px, -5px);
      -webkit-transform: rotate(135deg) translate(0px, -5px);
    }

    &.right {
      transform: rotate(-45deg) translate(-5px, 0px);
      -webkit-transform: rotate(-45deg) translate(-5px, 0px);
    }
  }

  .buttonNext {
    width: 60px;
    height: 60px;
    transform: scale(0.7);
    background: #e8e8e0 0% 0% no-repeat padding-box;
    border-radius: 50%;
    box-shadow: -5px -5px 10px #ffffff, 4px 4px 10px #d1d1d0;
    color: ${(props) => props.buttonTheme};
    opacity: 1;
    z-index: 999;

    @media screen and (max-width: 1200px) {
      transform: scale(0.7);
    }

    @media screen and (max-width: 768px) {
      transform: scale(0.6);
    }

    @media screen and (max-width: 576px) {
      transform: scale(0.5);
    }
  }

  .right {
    transform: rotate(-45deg) translate(-5px, 0px);
    -webkit-transform: rotate(-45deg) translate(-5px, 0px);
  }
`;

const backgroundTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #FAEB57 0%, #E59801 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const AdvertisingComponent = ({ promoteList, common, pageName }) => {
  const ref = useRef(null);

  const goNext = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper.slidePrev();
    }
  };

  const params = {
    modules: [Navigation, Pagination, Autoplay],
    pagination: {
      clickable: true,
      el: ".swiper-pagination.customized-swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: true,
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: false,
    // },
    spaceBetween: 30,
    slidesPerView: 1,
  };
  return (
    <WrapperAdvertising
      theme={backgroundTheme[pageName].background}
      buttonTheme={backgroundTheme[pageName].color}
      className="w-full mt-5"
    >
      <div className="imageLeft">
        <img src={promoteList.image.url} alt="" />
      </div>
      <div className="textRight">
        <Swiper {...params} ref={ref} className="mySwiper">
          {promoteList.promote.map((items, idx) => (
            <SwiperSlide key={idx} className='overflow-hidden'>
              <div className="mb-5 text-header font-extra">{items.promoteHeader}</div>
              <div
                className="text-body font-bold"
                dangerouslySetInnerHTML={{
                  __html: items.promoteContent,
                }}
              ></div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className="flex justify-between"
          style={{ transform: "translate(0px, -70px)" }}
        >
          <button className="buttonPre" onClick={goPrev}>
            <i className="arrow left"></i>
          </button>
          <button className="buttonNext" onClick={goNext}>
            <i className="arrow right"></i>
          </button>
        </div>
      </div>
    </WrapperAdvertising>
  );
};

export default AdvertisingComponent;
